import { AppAction, AppActions } from './app.actions';
import { Idol, Settings, Token, User, Wallet } from './app.models';

export interface AppState {
  idols: Idol[];
  settings: Settings;
  tokens: Token[];
  user: User;
  users: User[];
  wallet: Wallet;
}

let appState: AppState = {
  idols: [],
  settings: {
    fingerprint: false,
    notifications: true
  },
  tokens: [],
  user: {
    uid: '',
    displayName: '',
    photoURL: '',
    email: ''
  },
  users: [],
  wallet: {
    address: '',
    mnemonic: '',
    ethers: 0
  }
};

export function IdolsReducer(state: AppState = appState, action: AppAction) {
  switch (action.type) {
    case AppActions.IDOLS_FETCH:
      return state.idols;
    case AppActions.IDOLS_FETCH_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}

export function UserReducer(state: AppState = appState, action: AppAction) {
  switch (action.type) {
    case AppActions.USER_FETCH:
      return state.user;
    case AppActions.USER_FETCH_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}

export function UsersReducer(state: AppState = appState, action: AppAction) {
  switch (action.type) {
    case AppActions.USERS_FETCH:
      return state.users;
    case AppActions.USERS_FETCH_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}

export function SettingsReducer(state: AppState = appState, action: AppAction) {
  switch (action.type) {
    case AppActions.SETTINGS_FETCH:
      return state.settings;
    case AppActions.SETTINGS_FETCH_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}

export function TokenReducer(state: AppState = appState, action: AppAction) {
  switch (action.type) {
    case AppActions.TOKENS_FETCH:
      return state.tokens;
    case AppActions.TOKENS_FETCH_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}

export function WalletReducer(state: AppState = appState, action: AppAction) {
  switch (action.type) {
    case AppActions.WALLET_FETCH:
      return state.wallet;
    case AppActions.WALLET_FETCH_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.reducer.ts